/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Rooms = {
    type: 'array',
    contains: {
        type: 'Room',
    },
};